var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.currentField.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }